// ManageColumns.js
import React, { useState } from "react";
import {
    Button, Popover, Box, TextField, Checkbox, FormControlLabel,
    FormGroup
} from "@mui/material";
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';

const ManageColumns = ({ widgetOptions, defaultSelected, onChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedColumns, setSelectedColumns] = useState(defaultSelected || []);

    const open = Boolean(anchorEl);
    const handleClick = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleToggle = (title) => {
        setSelectedColumns((prev) => {
            const updated =
                prev.includes(title) ? prev.filter((t) => t !== title) : [...prev, title];
            onChange?.(updated);
            return updated;
        });
    };

    const handleShowAll = () => {
        setSelectedColumns(widgetOptions);
        onChange?.(widgetOptions);
    };

    const handleHideAll = () => {
        setSelectedColumns([]);
        onChange?.([]);
    };

    const filteredOptions = widgetOptions.filter((opt) =>
        opt.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <Button
                variant="contained"
                onClick={handleClick}
                sx={{
                    textTransform: "capitalize",
                    color: '#000',
                    background: 'none',
                    width: '180px',
                    boxShadow: 'none',
                    borderRadius: '40px',
                    border: !anchorEl ? '1px solid #ddd' : '1px solid #0463ef',
                }}

            >
                <ViewColumnOutlinedIcon sx={{ fontSize: '22px', marginRight: '1px' }} />   Manage Columns

            </Button>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                PaperProps={{ sx: { width: 260, borderRadius: 2, padding: '6px 14px' } }}
            >
                <TextField
                    size="small"
                    fullWidth
                    placeholder="Search columns..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ my: 1 }}
                />

                <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
                    <Button variant="outlined" size="small" onClick={handleShowAll} fullWidth>
                        Show All
                    </Button>
                    <Button variant="outlined" size="small" onClick={handleHideAll} fullWidth>
                        Hide All
                    </Button>
                </Box>

                <FormGroup sx={{ maxHeight: 200, overflowY: "auto", display: 'block' }}>
                    {filteredOptions.map((title) => (
                        <FormControlLabel
                            sx={{
                                display: 'block'
                            }}
                            key={title}
                            control={
                                <Checkbox
                                    checked={selectedColumns.includes(title)}
                                    onChange={() => handleToggle(title)}
                                />
                            }
                            label={title}
                        />
                    ))}
                </FormGroup>
            </Popover>
        </>
    );
};
export default ManageColumns;